export default __webpack_public_path__ + "static/media/dashboard_ArrowIcon.9c4f059c.svg";